export async function importKey(jwk: JsonWebKey, subtleCrypto: SubtleCrypto) {
    return subtleCrypto.importKey('jwk', jwk, 'AES-GCM', false, ['encrypt', 'decrypt']);
}
